/**
 * VELUNA GLOW AURA — progressive enhancement.
 *
 * 1. A scroll-reveal system for elements marked [data-veluna-reveal].
 * 2. A guard that keeps the header in drawer mode when it is locked there.
 *
 * Everything degrades to fully-visible, fully-usable content when JS or
 * IntersectionObserver is unavailable, and animation is skipped entirely under
 * prefers-reduced-motion.
 */
(function () {
  'use strict';

  // Flag the document so CSS knows JS is alive and reveals may start hidden.
  document.documentElement.classList.add('veluna-js');

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Scroll reveal ----------------------------------------------------- */

  function revealAll(nodes) {
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-revealed');
  }

  function initReveals(root) {
    var nodes = (root || document).querySelectorAll('[data-veluna-reveal]:not(.is-revealed)');
    if (!nodes.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      revealAll(nodes);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    for (var i = 0; i < nodes.length; i++) observer.observe(nodes[i]);
  }

  /* --- Drawer lock -------------------------------------------------------
   * layout/theme.liquid sets data-menu-lock="drawer" when the navigation should
   * always be a drawer. The theme recalculates data-menu-style on resize, so we
   * watch the attribute and put it back rather than racing it.
   * ---------------------------------------------------------------------- */

  function lockDrawerMenu() {
    var header = document.querySelector('#header-component');
    if (!header || header.dataset.menuLock !== 'drawer') return;
    if (!('MutationObserver' in window)) return;

    var enforce = function () {
      if (header.dataset.menuStyle !== 'drawer') header.dataset.menuStyle = 'drawer';
    };

    enforce();

    new MutationObserver(enforce).observe(header, {
      attributes: true,
      attributeFilter: ['data-menu-style'],
    });
  }

  /* --- Boot -------------------------------------------------------------- */

  function init(root) {
    initReveals(root);
    lockDrawerMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Re-scan when the theme editor swaps a section in.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
